import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Badge Component
 * Based on shadcn/ui Badge with DckSlap dark red theme
 */

const badgeVariants = {
    default: "border-transparent bg-primary text-primary-foreground",
    secondary: "border-transparent bg-secondary text-secondary-foreground",
    destructive: "border-transparent bg-destructive text-destructive-foreground",
    success: "border-transparent bg-success text-success-foreground",
    outline: "text-foreground border-border",
    ghost: "border-transparent bg-muted text-muted-foreground",
};

function Badge({ className, variant = "default", ...props }) {
    return (
        <div
            className={cn(
                "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
                "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
                badgeVariants[variant] || badgeVariants.default,
                className
            )}
            {...props}
        />
    );
}

export { Badge, badgeVariants };
